export default __webpack_public_path__ + "assets/images/7993174ebc2d660febbfda0dd75619b7.png";